import React, { FunctionComponent } from 'react';
import type { RecruitmentShowContentFollowSliderTopProps } from './types';
import type { Recruitment } from '../../../types/recruitmentShow';

type Props = & RecruitmentShowContentFollowSliderTopProps & {
  applications: Recruitment[];
};

export const Presentation: FunctionComponent<Props> = ({
  title,
  noimage,
  companyId,
  recruitmentId,
  isStopped,
  target,
  dataCategory,
  dataValue,
  applications,
}) => {
  if (!applications.length) return null;
  return (
    <div className={`recruitment__show__content recruitment__show__company ${isStopped ? 'is-stopped' : ''}`} id="company-recruitments-section">
      <h3 className="mainTitle">
        {title}
        <a
          className="link gtm-button-view-count"
          href={`/companies/${companyId}/recruitments`}
          data-event-name='button on screen'
          data-event="click"
          data-category={dataCategory}
          data-value={dataValue?.moreRelatedSelfRecruitments}
        >
          もっと見る
        </a>
      </h3>
      <div className="recruitment__show__applications__slider js-recruitment-show-content-follow-top">
        {applications.map((application) => (
          <a
            key={application.id}
            href={`/recruitments/${application.id}`}
            data-event-name='recruitments on screen'
            data-event="click"
            data-category={dataCategory}
            data-value={dataValue?.relatedSelfRecruitments}
            data-recruitmentid={application.id}
            data-companyid={application.companyId}
            target="_blank"
            className="box gtm-recruitment-view-count"
          >
            <img
              src={application.image.url || noimage}
              alt={`${application.title}の画像`}
            />
            <p className="title">
              <span className="occupation">{application.title}</span>
              <span className="prefecture">{application.prefecture}</span>
            </p>
            <p className="body">{application.body}</p>
          </a>
        ))}
      </div>
    </div>
  );
};
